import { TextField } from "@mui/material";
import DeleteUsersButton from "./DeleteUsersButton";
import ManageCreditLimitButton from "./ManageCreditLimitButton";
import ResendWelcomeEmailButton from "./ResendWelcomeEmailButton";
import UpdateNotificationsButton from "./UpdateNotificationsButton";
import UpdateRolesButton from "./UpdateRolesButton";
import { User } from "@/api/users";

export function UsersToolbar({
  roles,
  users,
  emailFilter,
  setEmailFilter,
}: {
  roles: string[];
  users: User[];
  emailFilter: string;
  setEmailFilter: (value: string) => void;
}) {
  return (
    <div className="flex gap-2 justify-content m-4">
      <TextField
        className="w-1/4"
        fullWidth
        label="Search Users"
        placeholder="Search Users"
        size="small"
        type="search"
        variant="outlined"
        value={emailFilter}
        onChange={(e) => setEmailFilter(e.target.value)}
      />
      <div className="flex gap-2 ml-auto">
        {users.length > 0 ? (
          <>
            <UpdateRolesButton roles={roles} users={users} />
            <UpdateNotificationsButton users={users} />
            <ResendWelcomeEmailButton users={users} />
            <DeleteUsersButton users={users} />
            <ManageCreditLimitButton users={users} />
          </>
        ) : null}
      </div>
    </div>
  );
}
